<div class="main-navigation">
  @if (featureTypes.includes(FeatureType.Complaints) && isUser) {
  <app-hover-menu>
    <div trigger>
      <img src="../../../../assets/images/parts.png" alt="Part Data" />
    </div>
    <div content>
      <a mat-menu-item [routerLink]="['/parts-charts']"> Parts Charts </a>
      <a mat-menu-item [routerLink]="['/parts-table']">
        Parts Table (Parts)
      </a>
      <a mat-menu-item [routerLink]="['/parts-mapping/eight-d-name']">
        Parts mapping
      </a>
      <a mat-menu-item> Parts versioning </a>
    </div>
  </app-hover-menu>
  }

  @if (featureTypes.includes(FeatureType.Claims) && isUser) {
  <app-hover-menu>
    <div trigger>
      <img src="../../../../assets/images/claim-icon.png" alt="Claim Data" />
    </div>
    <div content>
      <a mat-menu-item [routerLink]="['/claims-charts']"> Claims Charts </a>
      <a mat-menu-item [routerLink]="['/claims-table']">
        Claims Table (Claims)
      </a>
      <a mat-menu-item [routerLink]="['/claim-mapping/base-claim-part-group']">
        Claims mapping
      </a>
      <a mat-menu-item [routerLink]="['/claim-versioning']">
        Claims versioning
      </a>
    </div>
  </app-hover-menu>
  }

  @if (featureTypes.includes(FeatureType.Documents) && isUser) {
  <app-hover-menu>
    <div trigger>
      <img src="../../../../assets/images/doc-mng.png" alt="Document Management" />
    </div>
    <div content>
      <a mat-menu-item [routerLink]="['/document-management']">
        Document Management
      </a>
    </div>
  </app-hover-menu>
  }

  @if (
  featureTypes.includes(FeatureType.Complaints0Km) && isComplaint0KmEnabled && isUser
  ) {
  <app-hover-menu>
    <div trigger>
      <img src="../../../../assets/images/0km-icon.png" alt="Issue Data" />
    </div>
    <div content>
      <a mat-menu-item [routerLink]="['/issues-table']">
        Issue Table (Issue)
      </a>
      <a mat-menu-item> Issue mapping </a>
      <a mat-menu-item> Issue versioning </a>
      @if (isSupplyOnEnabled) {
      <a mat-menu-item [routerLink]="['/supplyon-team-members']">
        SupplyOn team members
      </a>
      }
    </div>
  </app-hover-menu>
  }

  @if (featureTypes.includes(FeatureType.CommonCharts) && isUser) {
  <app-hover-menu>
    <div trigger>
      <img src="../../../../assets/images/claim-icon.png" alt="Common Charts" />
    </div>
    <div content>
      <a mat-menu-item [routerLink]="['/common-charts']">Common Charts</a>
    </div>
  </app-hover-menu>
  }

  @if (featureTypes.includes(FeatureType.KpiScorecards) && isUser) {
  <app-hover-menu>
    <div trigger>
      <img src="../../../../assets/images/kpi-scorecards.png" alt="KPI Scorecards" />
    </div>
    <div content>
      <a mat-menu-item [routerLink]="['/kpi-scorecards']"> KPI Scorecards </a>
    </div>
  </app-hover-menu>
  }

  @if (isUser && isPocFormEnabled) {
  <app-hover-menu>
    <div trigger>
      <img src="../../../../assets/images/poc-warranty.png" alt="PoC" />
    </div>
    <div content>
      <a mat-menu-item [routerLink]="['/poc']"> PoC </a>
    </div>
  </app-hover-menu>
  }

  @if (isUser) {
  <button class="pointer-cursor-button" [routerLink]="['/import']">
    <img src="../../../../assets/images/upload.png" alt="Import" />
  </button>
  }

  @if (isSuperAdmin) {
  <a class="pointer-cursor-button" [routerLink]="['/admin']">
    <img src="../../../../assets/images/user.png" alt="Admin" />
  </a>
  }
</div>
